import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "write bg-white shadow flex justify-between items-center rounded-b-lg space-x-2 px-2 py-2" }
const _hoisted_2 = { class: "flex space-x-4 cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      title: "Uma tecnologia, Chatmix",
      href: "",
      class: _normalizeClass(["sr-only", [
                'flex font-normal text-[.65em] text-neutral-700 text-opacity-40 outline-none',
                'webchat-transition hover:text-opacity-70 focus:text-neutral-900 focus:text-opacity-100'
            ]])
    }, " Chatmix ", 2),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          class: _normalizeClass([
                    'outline-none text-center text-neutral-400 webchat-transition',
                    'hover:text-neutral-700 focus:text-neutral-900'
                ])
        }, [
          _createVNode(_component_Icon, {
            name: item.icon,
            size: item.size,
            class: "block text-center",
            title: item.title,
            onClick: () => _ctx.emit('update', item.action)
          }, null, 8, ["name", "size", "title", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}